
    import * as React from 'react';

    const ArrowDown12 = ({ color = 'currentcolor', height = '12px', width = '12px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 12 12" style={svgStyle}><path d="M5.623 9.789l-3.54-3.573-.533.528 4.448 4.489 4.45-4.49-.533-.527-3.542 3.573V.7h-.75v9.089z" /></svg>
        </div>
      );
    };

    ArrowDown12.displayName = 'ArrowDown12';

    export default ArrowDown12;
  